module.exports = __webpack_public_path__ + "static/img/zj07.799a9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zj07.png
// module id = 144
// module chunks = 0